import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import css from "./SelectSampleMenuModal.module.css";
import { SearchInputComponentModal } from "../SearchInputComponentModal/SearchInputComponentModal";
import { dishesActions } from "../../../../store/slices/dishes-slices";
import { SelectSingleSampleModal } from "../SelectSingleSampleModal/SelectSingleSampleModal";
import { sampleMenuActions } from "../../../../store/slices/menu-slices";

const SelectSampleMenuModal = ({ setIsOpen }) => {
  const dispatch = useDispatch();
  const { dishesArray, trigger, dishesFiltered, searchActive } = useSelector(
    (store) => store.dishes
  );

  useEffect(() => {
    dispatch(dishesActions.getAllDishes());
  }, [trigger, dispatch]);

  const dishesToRender = searchActive ? dishesFiltered : dishesArray;

  const closeSampleMenuModal = () => {
    dispatch(sampleMenuActions.changeIdMatching(""));
    setIsOpen(false);
  };

  return (
    <div className={css.overlay}>
      <div className={css.modal}>
        <div className={css.header}>
          <h2>Select dish</h2>
          <button className={css.closeButton} onClick={closeSampleMenuModal}>
            &times;
          </button>
        </div>

        <div className={css.blockInput}>
          <SearchInputComponentModal />
        </div>

        <div className={css.table}>
          <div className={css.tableHeader}>
            <div className={css.tableHeaderImage}>Image</div>
            <div className={css.tableHeaderName}>Name</div>
            <div className={css.tableHeaderCat}>Category</div>
            <div className={css.tableHeaderWeight}>Weight</div>
            <div className={css.tableHeaderWeightNetto}>Weight Netto</div>
            <div className={css.tableHeaderCost}>Cost</div>
            <div className={css.tableHeaderPrice}>Price</div>
          </div>

          <div className={css.tableBody}>
            {dishesToRender && dishesToRender.length > 0 ? (
              dishesToRender.map((obj) => (
                <SelectSingleSampleModal
                  key={obj.id}
                  dish={obj}
                  setIsOpen={setIsOpen}
                />
              ))
            ) : (
              <div className={css.noResults}>
                {searchActive
                  ? "No dishes found matching your search"
                  : "No dishes available"}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export { SelectSampleMenuModal };
